
// Define action constants
module.exports = {
  RECEIVE_DATA : 8
};


/** WEBPACK FOOTER **
 ** ./src/constants/TrendConstants.js
 **/